/** Orba One's backend has standardized error responses
 * This file simply houses the parser for those error messages
 */

import { AxiosError } from "axios";

export interface OrbaOneError {
  code: string;
  message: string;
}
const capitalizeFirstWord = (word) =>
  word.replace(/^\w/, (c) => c.toUpperCase());

export const errorParser = (error: AxiosError): string => {
  const { response } = error;
  if (response?.data) {
    const { data } = response;
    if (data?.errors) {
      const { errors } = data;
      if (errors.length > 0) {
        //Return the top error message
        return capitalizeFirstWord(errors[0].message);
      } else {
        return "";
      }
    } else {
      return "";
    }
  } else {
    return "";
  }
};
